import {dashStylesHelper, roundLineJoinsHelper} from './util';

export const postRender = (highchart, options) => {
  const lineInFront = ['area', 'bar', 'column'].includes(options.type);
  const gPlotLines = [...highchart.container.querySelectorAll(lineInFront ? '.highcharts-plot-lines-5' : '.highcharts-plot-lines-3')][0];
  const paths = gPlotLines.querySelectorAll('path');
  const isVideoGroup = (options.id === 'video' || options.id === 'twitterVideo');
  paths.forEach(path => {
    dashStylesHelper(path, options.size);
    roundLineJoinsHelper(path, isVideoGroup);
  })
}



// WEBPACK FOOTER //
// ./src/chart/inner/plotLines-postrender.js